import { NotificationType } from '../../../../../services/exports/Constants';

export default {
  title: 'Hai {{length}} avvisi',
  notifications: {
    titles: {
      [NotificationType.PaymentGatewayVerificationPending]: 'Info pagamento in revisione',
      [NotificationType.PaymentGatewayVerificationSuccessful]: 'Info pagamento verificate',
      [NotificationType.PaymentGatewayVerificationFailed]: 'Errore info pagamento',
    },
    descriptions: {
      [NotificationType.PaymentGatewayVerificationPending]:
        "Le informazioni di pagamento sono in fase di revisione da parte di Stripe. L'operazione potrebbe richiedere fino a 48 ore.",
      [NotificationType.PaymentGatewayVerificationSuccessful]:
        'Le informazioni di pagamento sono state verificate con successo. Ora puoi ricevere pagamenti.',
      [NotificationType.PaymentGatewayVerificationFailed]:
        'Si è verificato un errore con le tue informazioni. Clicca qui per aggiornare i tuoi dati.',
    },
  },
};
